import React, { useEffect } from "react";
import { createPortal } from "react-dom";

const typeClassMap = {
    success: "bg-green-600",
    error: "bg-red-600",
    info: "bg-blue-600",
    warning: "bg-yellow-600"
};

const Toast = ({ show, message, type = "info", onClose, duration = 3500, topOffset = 80 }) => {
    useEffect(() => {
        if (!show) return;

        const timerId = setTimeout(() => {
            if (typeof onClose === "function") {
                onClose();
            }
        }, duration);

        return () => clearTimeout(timerId);
    }, [show, duration, onClose]);

    if (!show || !message) return null;

    const toastNode = (
        <div className="fixed right-5 z-[1000] max-w-sm w-[90vw]" style={{ top: `${topOffset}px` }}>
            <div className={`${typeClassMap[type] || typeClassMap.info} text-white px-4 py-3 rounded shadow-lg flex items-start justify-between gap-3`}>
                <span className="text-sm leading-5">{message}</span>
                <button
                    type="button"
                    onClick={onClose}
                    className="font-bold leading-none text-white opacity-80 hover:opacity-100"
                    aria-label="Close toast"
                >
                    x
                </button>
            </div>
        </div>
    );

    if (typeof document === "undefined") {
        return toastNode;
    }

    return createPortal(
        <div className="z-[9999]">{toastNode}</div>,
        document.body
    );
};

export default Toast;
